import { Button } from "@mgdx/ui/components/Button";
import { InputOptionList } from "@mgdx/ui/components/InputOptionList";
import { Text } from "@mgdx/ui/components/Text";
import { Textarea } from "@mgdx/ui/components/Textarea";
import { Title } from "@mgdx/ui/components/Title";
import { useFormik } from "formik";
import * as Yup from "yup";

import { DeleteUser } from "../../hooks/useDeleteUser";

const validationSchema = Yup.object().shape({
  reasons: Yup.array().of(Yup.string()),
  message: Yup.string().nullable(false),
});

export type Props = {
  deleteUser: DeleteUser;
};

export const checkboxLabels = {
  noUsablePharmacies: "利用したい医療機関/薬局がない",
  hardToUse: "サービスが使いづらい",
  notCorrectlyWorking: "正常に動作しなかった",
};

export const AccountDeleteView = ({ deleteUser }: Props) => {
  const formik = useFormik({
    initialValues: {
      reasons: [],
      message: "",
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      const { reasons, message } = values;
      await deleteUser({ reasons, message });

      setSubmitting(false);
    },
  });

  return (
    <>
      <Title as="h1">退会の確認</Title>

      <Text className="mt-2">薬急便を退会してよろしいですか ?</Text>

      <form
        id="AccountDeleteView-form"
        onSubmit={formik.handleSubmit}
        className="flex flex-col items-center"
        noValidate={true}
      >
        <InputOptionList
          name="reasons"
          type="checkbox"
          label="退会理由(複数可)"
          disabled={formik.isSubmitting}
          onChange={(value) => {
            formik.setFieldValue("reasons", value);
          }}
          options={[
            {
              label: "利用したい医療機関/薬局がない",
              value: "利用したい医療機関/薬局がない",
            },
            {
              label: "サービスが使いづらい",
              value: "サービスが使いづらい",
            },
            {
              label: "正常に動作しなかった",
              value: "正常に動作しなかった",
            },
          ]}
          className="mt-6"
          message={typeof formik.errors.reasons === "string" ? formik.errors.reasons : undefined}
          value={formik.values.reasons}
        />

        <Textarea
          name="message"
          label="その他のご意見ご感想"
          placeholder="サービスの改善に日々努めてまいりますので、ご意見ご感想をお願いします。"
          message={formik.errors.message}
          value={formik.values.message}
          onChange={formik.handleChange}
          disabled={formik.isSubmitting}
          error={!!formik.errors.message}
          rows={4}
          className="mt-4"
        />

        <Button type="submit" variant="filled" loading={formik.isSubmitting} className="mt-2">
          薬急便を退会する
        </Button>
      </form>
    </>
  );
};
